// src/components/VtoModal.jsx
import React, { useEffect, useRef } from 'react'
import { DeepAR } from 'deepar'

export default function VtoModal({ open, effectUrl, onClose }) {
  const canvasRef = useRef(null)
  const arRef     = useRef(null)

  useEffect(() => {
    if (!open) return

    ;(async () => {
      arRef.current = await DeepAR({
        licenseKey   : process.env.REACT_APP_DEEPAR_KEY,
        canvas       : canvasRef.current,
        numberOfFaces: 1,
        viewport     : { x: 0, y: 0, width: 1, height: 1 }
      })
      try {
        await arRef.current.startVideo(true)      // ask for camera
        if (effectUrl) await arRef.current.loadEffectFromURL(effectUrl)
      } catch (err) {
        console.error('[VtoModal]', err)
      }
    })()

    return () => {
      arRef.current?.destroy()
    }
  }, [open, effectUrl])

  if (!open) return null

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-black text-xl"
        >
          ✕
        </button>
        <canvas
          ref={canvasRef}
          width={360}
          height={480}
          className="rounded"
        />
      </div>
    </div>
  )
}
